import { gridClasses } from '@mui/x-data-grid';

const gridSxStyle = {
  [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
    outline: "none"
  },
  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]: {
    outline: "none"
  },
  '& .MuiDataGrid-cell': {
    border: '1px solid var(--color-grey)',
    borderBottom: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    alignItems: 'flex-start', // Align content at the top of the cell
    display: 'flex',          // Ensure flexbox layout is applied
    paddingTop: '5px', // Add some padding to the top of the cell
  },

  '& .MuiDataGrid-renderingZone': {
//    alignItems: 'flex-start', // Align the rendering zone at the top
  },
  '& .MuiDataGrid-cellContent': {
    //justifyContent: 'flex-start', // Ensure content within cells is aligned at the top
    // textAlign: 'left',            // Keep text aligned to the left
  },

  border: '1px solid var(--color-grey)',

  '& .MuiDataGrid-row.Mui-selected': {
    background: 'var(--color-selected)',
    borderRadius: ' 5px',
  },

  /* "& .MuiDataGrid-root": {
     // border: "0px solid lightgray",
     // borderRadius: "0px",
     backgroundColor: "#0f0",
   },
   '& .MuiDataGrid-iconSeparator': {
     display: 'none',
   },
   */
  //'& .MuiPaginationItem-root': {
  // borderRadius: 0,
  //}

}

export default gridSxStyle;